import { getEnv } from '@hub/helpers/getters.store';
import UsersService from '@hub/services/entities/users-service';
import { EntityStore } from '../base/entity-store';

//TODO: add user type
export class UsersStore extends EntityStore<
  UsersService,
  unknown & { _id: string }
> {
  constructor() {
    const {
      apiFactory: { usersService },
    } = getEnv();

    super(usersService);
  }
}
